import { motion, HTMLMotionProps } from 'framer-motion';
import { ReactNode } from 'react';
import { useReducedMotion } from '@/lib/motion/hooks/use-reduced-motion';

interface FloatProps extends Omit<HTMLMotionProps<'div'>, 'children'> {
  children: ReactNode;
  /** Float distance in pixels */
  distance?: number;
  /** Animation duration in seconds */
  duration?: number;
  /** Delay before starting */
  delay?: number;
  className?: string;
}

export function Float({
  children,
  distance = 8,
  duration = 3,
  delay = 0,
  className,
  ...props
}: FloatProps) {
  const reducedMotion = useReducedMotion();

  if (reducedMotion) {
    return <div className={className}>{children}</div>;
  }

  return (
    <motion.div
      animate={{
        y: [-distance / 2, distance / 2, -distance / 2],
      }}
      transition={{
        duration,
        repeat: Infinity,
        ease: 'easeInOut',
        delay,
      }}
      className={className}
      {...props}
    >
      {children}
    </motion.div>
  );
}
